export default "__VITE_ASSET__e26f692a__"